import Modal from 'developer_components/newModal';
import DefaultDialog from 'components/tourist-leads/dialogs/default';
import TouristLeadsForm from 'components/tourist-leads/form';

function FormModal(options = {}) {
    if (typeof window.touristLeadsModal !== 'undefined') {
        return window.touristLeadsModal;
    }

    // инициализация модального окна
    const $modal = Modal.createFromHTML(`
        <div class="Tourist-leads-form-modal js-tourist-leads-form-modal">
            <div class="Tourist-leads-form-modal__image">
                <img src="/app/src/img/call_headphones-without-bg.png" />
            </div>
        </div>
    `, {id: 'Tourist-leads-form-modal'});

    Modal.call(this, $modal, options);

    window.touristLeadsModal = this;

    // инициализация формы
    this.form = this.makeForm({
        on: {
            submit: () => {
                setTimeout(() => new DefaultDialog(), 500);
            },
        },
        source: 'site',
    });

    // добавление формы в модальное окно
    this.$element.querySelector('.js-tourist-leads-form-modal').insertAdjacentElement('afterbegin', this.form.$element);
}

FormModal.prototype = Object.create(Modal.prototype);
Object.defineProperty(FormModal.prototype, 'constructor', {
    value: FormModal,
    enumerable: false,
    writable: true,
});

FormModal.prototype.makeForm = function(options) {
    return new TouristLeadsForm(options)
        .section({
            description: `
                <p class="pretitle">Всего 1 шаг и можно брать отпуск</p>
                <p class="title">Заявка на персональный подбор жилья</p>
            `,
        })
        .section({
            pickers: true,
        })
        .section({
            destination: {
                label: 'Где подобрать жилье',
                placeholder: 'Сочи',
            },
        })
        .section({
            comment: {
                rows: 3,
            },
        })
        .section({
            name: true,
        })
        .section({
            phone: true,
            email: {
                message: {
                    show: true,
                    text: 'Свяжемся с вами по телефону, а на почту отправим подтверждение заявки',
                },
            },
            input: {
                name: 'subs_place',
                value: 'no_objects_subscription',
                id: 'no_objects_subscription',
            },
        })
        .section({
            agreement: true,
        })
        .section({
            mailing: true,
        })
        .section({
            submitter: {
                disabled: true,
            },
        });
}

export default FormModal;
